<template>
  <div>Resetting your context</div>
</template>

<script>
  export default {
    data: () => ({
    }),
    created: async function () {
      this.$store.dispatch('ResetResellerContext')
    },
    methods: {
    },
  }
</script>
